import React from "react";
import { Row, Form, Input } from "antd";

import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
// import { useNavigate } from "react-router-dom";

import useMapData from "../../utils/useMapData";

import { openNotification, validateEmail } from "../../utils";
import { ReqActionBtn } from "../../StyledCmp";
import { useParams } from "react-router-dom";

import { getDatabase, ref as dbRef, update } from "firebase/database";
import { app } from "../../utils/firebase";

const RegisterForm = ({
  subTitle = "Pre-Register here for Best Offers",
  btnText = "Pre-Register Now",
  actionType = "pre-register",
  handleModalVisibility,
}) => {
  const [form] = Form.useForm();
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const db = getDatabase(app);

  // const navigate = useNavigate();

  const keydownHandler = event => {
    // if key is enter key
    if (event.keyCode === 13) {
      handleSignup();
    }
  };

  const handleSignup = async () => {
    const values = form.getFieldsValue();
    const fieldError = form.getFieldsError();

    const { name, phone, email } = values;

    // console.log(actionType);
    // console.log({ values, actionType });

    if (!name || !phone || !email) {
      return openNotification("Please enter details!");
    }

    if (!validateEmail(email)) {
      return openNotification("You have entered an invalid email address!");
    }

    if (fieldError[0].errors.length > 0) {
      return openNotification("Please enter valid name!");
    }

    if (!isValidPhoneNumber(phone)) {
      return openNotification("Please enter an valid phone number!");
    }

    let uid = Date.now();

    let leadsData = {
      id: uid,
      name,
      phone,
      email,
      actionType,
      status: "info",
    };

    try {
      update(dbRef(db, `/all/${propertyId}/leadsData/${uid}`), leadsData);
      openNotification("Register Success!");
      // navigate("/register_success");
    } catch (error) {
      openNotification(error.message || "Try registering again!");
    } finally {
      console.log(actionType === "pre-register");
      if (actionType === "pre-register") {
        form.resetFields();
        return console.log("pre-register");
      }
      form.resetFields();
      console.log("not preRegister");
      return handleModalVisibility();
    }
  };

  return (
    <Row justify="space-around" className="pre_register">
      <h3>{subTitle}</h3>
      <Form
        className="register_form"
        autoComplete="off"
        autoSave="off"
        form={form}
        onFinish={handleSignup}
      >
        <div className="form_item">
          <p>Name</p>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                type: "string",
                message: "Please input your name!",
              },
            ]}
          >
            <Input autoFocus className="form_input" placeholder="Name" />
          </Form.Item>
        </div>
        <div className="form_item">
          <p>Phone number</p>
          <Form.Item
            name="phone"
            rules={[
              () => ({
                validator(_, value) {
                  if (value && isValidPhoneNumber(value)) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error("Please enter a valid phone number!")
                  );
                },
              }),
            ]}
          >
            <PhoneInput
              placeholder="Enter phone number"
              defaultCountry="AE"
              limitMaxLength
              className="phone-input"
            />
          </Form.Item>
        </div>
        <div className="form_item">
          <p>Email</p>
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                message: "Please enter an valid email!",
              },
              {
                required: true,
                message: "Please input your E-mail!",
              },
            ]}
          >
            <Input className="form_input" placeholder="Email" />
          </Form.Item>
        </div>

        <div className="register_button">
          <ReqActionBtn
            onKeyDown={keydownHandler}
            style={{ color: resultList.themeColor }}
          >
            {btnText}
          </ReqActionBtn>
        </div>
      </Form>
    </Row>
  );
};

export default RegisterForm;
